import { helperFunctions } from 'utils/helperFunctions';

export const formatApiResponseTime = (valueInMs) => {
  if (helperFunctions().isInvalidValue(valueInMs) || isNaN(valueInMs)) {
    return 'NA';
  }
  // If the value is within 100 milliseconds, display as ms.
  if (valueInMs <= 100) {
    const abrValue = valueInMs;
    const abrUnit = 'ms';
    return abrValue + ' ' + abrUnit;
  } else {
    // Otherwise, convert to seconds.
    const seconds = valueInMs / 1000;
    const abrValue = helperFunctions().getValueAbbreviationParser(seconds);
    const abrUnit = helperFunctions().getAbbrUnit('seconds', seconds);
    return abrValue + ' ' + abrUnit;
  }
};

export const formatApiResponseTimeWithSeconds = (msValue) => {
  if (helperFunctions().isInvalidValue(msValue)) {
    return 'NA';
  }

  // If the API response time is 100ms or less, display in milliseconds.
  if (msValue <= 100) {
    return `${msValue} ms`;
  }

  // Convert milliseconds to seconds for further formatting.
  const secondsValue = msValue / 1000;

  // For times less than 60 seconds, display in seconds.
  if (secondsValue < 60) {
    // Use more precision if less than 1 second.
    return `${secondsValue.toFixed(1)} s`;
  } else if (secondsValue < 3600) {
    // For times between 60 seconds and 3600 seconds, display minutes and remaining seconds.
    const minutes = Math.floor(secondsValue / 60);
    const seconds = Math.round(secondsValue % 60);
    return seconds === 0 ? `${minutes} m` : `${minutes} m ${seconds} s`;
  } else if (secondsValue >= 3601 && secondsValue <= 3659) {
    // Special case: when the time is between 3601 and 3659 seconds,
    // display it as 1 hour plus the extra seconds.
    const hours = 1;
    const seconds = Math.round(secondsValue - 3600);
    return `${hours} h ${seconds} s`;
  } else {
    // For times above 3600 seconds (excluding the special case), display hours and minutes.
    const hours = Math.floor(secondsValue / 3600);
    const minutes = Math.floor((secondsValue % 3600) / 60);
    return minutes === 0 ? `${hours} h` : `${hours} h ${minutes} m`;
  }
};
